module.exports={select:"Вибрати",selected:"Вибрано"};